import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

/* jquery */
declare var $: any;

@Component({
  selector: 'app-financial-information',
  templateUrl: './financial-information.component.html',
  styles: [
  ]
})
export class FinancialInformationComponent implements OnInit, OnDestroy{

  dataTitle;
  dataSection = [];
  year;
  dataYear = [];
  dataFinancial;
  dataPerFinancial;
  isActivePdf;
  isLang;

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // MultiLanguage
   this.isLang =  this.apiService.isLang();

    // Content
    this.apiService.getDataApi('getMenuSection/financial-information').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });
    
    // docs
    this.apiService.getDataApi('getDocumentYear?category=1').subscribe(response => {
       this.dataFinancial = response.data;
       this.isActivePdf = response.isActive;
        response.data.forEach((i,x) => {
          if(i.year){
            this.dataYear.push(i.year);
          }
          this.year = this.dataYear[0];
          if(this.year == i.year){
            this.dataPerFinancial = i.content;
          }
        });
    });
  }
  
  valueChanged(event: string) {
    this.dataFinancial.forEach((i,x) => {
      if(i.year == event){
        this.dataPerFinancial = i.content;
      }
    });
  }

  ngOnDestroy(){
    /* clear select2 */
    const selectOptionsContainer = $('.select2-container');
    selectOptionsContainer.removeClass('select2-container--open');
  }

}
